import * as Config from '../../../../../config';
import React from 'react';
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import PropTypes from 'prop-types';

import GridCharts from '../../../content/grid/GridCharts';
import GridReleases from '../../../content/grid/GridReleases';

function ConnectedGenresRoute({ url, id, name, dimension, hasSideMenu }) {
  const { width, height } = dimension;

  return (
    <Switch>
      <Route path={`${url}/releases`}>
        <GridReleases id={`${name}_releases`} 
          width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width} 
          perPage={100}
          height={ height - (Config.TAB_BAR_GUTTER * 4.3) }
          style={{ marginTop: -15 }} 
          hasFilters={true} 
          filtersStyle={{ top: 80, height: 250, marginTop: -7 }}
          buttonFilterStyle={{ top: 23 }}
          pathApi={`/v4/catalog/releases/?genre_id=${id}&enabled=true&preorder=false&order_by=-publish_date&per_page=100` /*&publish_date=:${dayjs().format(`YYYY-MM-DD`)}*/}
          className={`grid-chart genre-all`}
          showLoading={true}
        />
      </Route>
      <Route path={`${url}/playlists`}>
        <GridCharts id={`${name}_playlists`} 
          width={ hasSideMenu ? width - Config.SUB_SIDEBAR : width}
          perPage={100}
          height={ height - (Config.TAB_BAR_GUTTER * 4.3) }
          style={{ marginTop: 6 }} filtersStyle={{ top: 80, height: 250, marginTop: -12 }}
          hasFilters={Config.GENRES_PLAYLISTS_HAS_FILTERS}
          buttonFilterStyle={{ top: 40 }}
          pathApi={`/v4/catalog/charts/?genre_id=${id}&enabled=true&is_published=true&per_page=100`}
          className={`grid-chart genre-all`}
          showLoading={true}
        />
      </Route>
    </Switch>
  );
}

ConnectedGenresRoute.propTypes = {
  url: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
}

const GenresRoute = connect(
  state => ({
    dimension: state.dimension
  })
)(ConnectedGenresRoute);

export default GenresRoute;
